import { decodeToken } from "@helpers"

const hasRight = (right) => {
  const jwtUser = decodeToken(sessionStorage?.adminToken || null)
  const rightKey = "has_" + right

  if (jwtUser?.impersonating) {
    return false
  }
  
  const rights = jwtUser ? jwtUser?.rights : null

  if (!rights) return false
  
  const value = rights[rightKey]

  return value === true || value === 1 || value === "1" 
}

export default hasRight